 function updateVerifiedBadge() {
    $('.stamped-main-widget, .stamped-verified-badge').hide();
    $('<span class="stamped-verified-badge" data-type="buyer" data-verified-label="Verified Buyer"></span>').insertAfter('.author');
  }

  function updateOnNextClick() {
    $('.next a').on('click', function() {
      setTimeout(function() {
        updateVerifiedBadge();
      }, 1000);
    });
  }

  function handleResize() {
    $(window).resize(function() {
      if (screen.width < 768) {
        $('#checkout_logo').insertAfter('#cart_blocks');
      }
    });
  }

  // Run the code after a delay
  setTimeout(function() {
    updateVerifiedBadge();
    updateOnNextClick();
    handleResize();
  }, 3000);

// Redirect to CHECKOUT instead of CART page
/*document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
    form.addEventListener("submit", function(event) {
      event.preventDefault();

      // Send the product to the cart with Ajax
      fetch('/cart/add', {
        method: 'POST',
        body: new FormData(form),
      }).then(function() {
        // Redirect to checkout immediately after adding to cart
        window.location.href = '/checkout';
      }).catch(function(error) {
        console.error('Error:', error);
      });
    });
  });
});*/
